module.exports = __webpack_public_path__ + "img/sin.ac64bf76.svg";